import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl, headersDefault } from "./index";

/**
 * Post-registration cards (Guest / Premium / Free-Trial)
 * Endpoint returns widgets similar to home widgets.
 */
export const fetchPreRegisterWidgets = createAsyncThunk(
  "preRegister/fetchWidgets",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/app/images/pre-register`,
        {
          headers: headersDefault(),
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Errore nel caricamento delle offerte. Riprova."
      );
    }
  }
);
